import { css, SerializedStyles } from '@emotion/react';
import { FC, HTMLAttributes } from 'react';
import { useTheme } from '@airwallex/theme';

interface Props {
  customStyle?: SerializedStyles;
}

export const Index: FC<Props & HTMLAttributes<HTMLDivElement>> = ({ customStyle, ...rest }) => {
  // Divider colour from the semantic `border.decorative` token (PAA-2711).
  const borderColor = useTheme().semanticColors.border.decorative;

  return (
    <div
      css={[
        customStyle,
        css`
          ${customStyle};
          border: none;
          height: 1px;
          background: ${borderColor};
        `,
      ]}
      {...rest}
    />
  );
};

export default Index;
